import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";

const organizationValidationSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup
      .string()
      .required("This field is required")
      .min(2, t("validations.min_length", { count: 2 }))
      .max(120, t("validations.max_length", { count: 120 })),
    description: yup
      .string()
      .required("This field is required")
      .max(500, t("validations.max_length", { count: 500 })),
    status: yup
      .string()
      .required("This field is required")
      .oneOf(["ACTIVE", "INACTIVE"], "Invalid status"),
    orgUnitLabelId: yup.array().of(yup.string().required()).default([]),
  });

export type OrganizationFormData = InferType<
  ReturnType<typeof organizationValidationSchema>
>;

export default organizationValidationSchema;
